import { FilterValue } from "../../lib/filter";
import { ListDataSource, NullListDataSource, ListItem } from "../datasource/list";
import { ItemId, Serializer } from "../datasource";

export abstract class ListModel<I extends ItemId> {
	datasource: ListDataSource<I>;

	protected constructor(datasource?: ListDataSource<I>) {
		this.datasource = datasource ?? new NullListDataSource(new Serializer());
	}

	abstract itemIdSerializer(): Serializer<I>;
	abstract getItemList(): Promise<ListItem<I>[]>
	abstract getItemIdMap(items?: ListItem<I>[]): Promise<Record<string, number>>;
	abstract getItemIndexMap(items?: ListItem<I>[]): Promise<string[]>;
	abstract getFilteredItems(items: ListItem<I>[], filters: FilterValue[]): Promise<ListItem<I>[]>
	abstract setAttributes(id: I, data: Partial<ListItem<I>>): void
}

export class NullListModel<I extends ItemId> implements ListModel<I> {
	datasource: ListDataSource<I>;

	itemIdSerializer(): Serializer<I> {
		throw new Error("Method not implemented.");
	}

	getItemList(): Promise<ListItem<I>[]> {
		throw new Error("Method not implemented.");
	}

	getItemIdMap(items?: ListItem<I>[]): Promise<Record<string, number>> {
		throw new Error("Method not implemented.");
	}

	getItemIndexMap(items?: ListItem<I>[]): Promise<string[]> {
		throw new Error("Method not implemented.");
	}

	getFilteredItems(items: ListItem<I>[], filters: FilterValue[]): Promise<ListItem<I>[]> {
		throw new Error("Method not implemented.");
	}

	setAttributes(id: I, data: Partial<ListItem<I>>): void {
		throw new Error("Method not implemented.");
	}
}

